import React, { useCallback, useEffect, useState, useRef } from "react";
import UnpaidServices from "./UnpaidServices";
// import React, { useRef } from "react";
import { RiCloseFill } from "react-icons/ri";
import TagInputs from "../layouts/TagInputs";
// import TextArea from "../../UI/TextArea";
// import VisitsTable from "../../tables/VisitsTable";
import { get, post } from "../../utility/fetch";
import notification from "../../utility/notification";
import { usePatient } from "../../contexts";
// import AppointmentModal from "../../modals/AppointmentModal";
// import Paginate from "../../UI/paginate";
// import { checkIfAppointmentPassed } from "../../../utility/general";
// import UploadButton from "../../../Input/UploadButton";
// import { RiDeleteBinLine } from "react-icons/ri";
// import EDMSFiles from "../../UI/EDMSFiles";
import { useNavigate } from "react-router-dom";
// import SpeechToTextButton from "../../UI/SpeechToTextButton";
import axios from "axios";

const MemoizedTagInputs = React.memo(TagInputs);

function AddExtraServices({ closeModal, patientId, appointmentId }) {
  const unpaidRef = useRef();
  // const { patientId } = usePatient();

  // eslint-disable-next-line no-unused-vars
  const [documentArray, setDocumentArray] = useState([]);
  const [payload, setPayload] = useState({
    dateOfVisit: "",
    temperature: "",
    bloodPressure: "",
    heartPulse: "",
    respiratory: "",
    height: 0,
    weight: 0,
    careType: 0,
    VitalNurseEmployeeId: Number(sessionStorage.getItem("userId")),
    appointmentId: null,
    notes: "",
    vitalDocuments: [],
    bloodSugar: "",
    oxygenSaturation: "",
  });

  const [isServicePaid, setIsServicePaid] = useState(true);
  const [vitalServicesFromAppointmentId, setVtalServicesFromAppointmentId] =
    useState();
  // eslint-disable-next-line no-unused-vars
  const [_nurses, setNurses] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [_docNames, _setDocNames] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [_doctors, setDoctors] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [_visits, setVisits] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [currentPage, _setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [_totalPages, setTotalPages] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [_loading, _setLoading] = useState(true);
  const [Appointments, setAppointments] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [_viewing, _setViewing] = useState(false);
  const [selectedMfiles, setSelectedMfiles] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [_add, _setAdd] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [_appointmentPassed, setAppointmentPassed] = useState(false);
  const navigate = useNavigate();
  const [services, setServices] = useState(null);
  const [service, setService] = useState({});
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState({});

  const getCategories = async () => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("Token not found in session storage");
      return;
    }

    const options = {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/healthfinanceapi/api/category/list/1/1000`,
        options,
      );

      const tempServices = res?.data?.resultList
        // ?.filter((service) => service.category.name === "Clinical Service" || service.category.name === "Clinical Services")
        .map((category) => ({
          label: category?.name,
          value: parseFloat(category?.id),
        }));

      tempServices?.unshift({ label: "Select Service", value: "" });

      setCategories(tempServices);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const getCategoriesService = useCallback(async () => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("Token not found in session storage");
      return;
    }

    const options = {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      setService({});
      setServices(null);
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/healthfinanceapi/api/categoryitem/list/category/${category?.value}/1/1000`,
        options,
      );

      const tempServices = res?.data?.resultList.map((service) => ({
        label: service?.itemName,
        value: parseFloat(service?.id),
      }));

      tempServices?.unshift({ label: "Select Service", value: "" });

      setServices(tempServices);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  }, [category?.value]);
  const handleSelectChange = useCallback((value, name) => {
    if (name === "nurse") {
      // setNurse(value);
      setPayload((prevPayload) => ({ ...prevPayload, NurseId: value?.value }));
    } else if (name === "category") {
      setCategory(value);
    } else {
      setService(value);
      setPayload((prevPayload) => ({
        ...prevPayload,
        serviceId: value?.value,
      }));
    }
  }, []);

  useEffect(() => {
    getCategoriesService();
  }, [category, getCategoriesService]);

  const submitServicePayload = async () => {
    let payloadz = {
      clinicId: +sessionStorage.getItem("clinicId"),
      categoryId: category.value,
      patientId: +patientId,
      categoryItemId: service.value,
      amount: 0,
      quantity: +payload.quantity,
      status: "Pending",
      appointmentId: Number(+appointmentId),
    };

    try {
      let res = await post("/patients/CreateVitalServicePayment", payloadz);
      if (res.message) {
        notification({ message: res.message, type: "success" });
        if (unpaidRef.current && unpaidRef.current.refresh) {
          unpaidRef.current.refresh();
        }
      }
    } catch (error) {
      console.log(error);
      notification({ message: "Failed to add Vital record", type: "error" });
    }
  };

  const fieldLabels = {
    dateOfVisit: "Visit Date",
    temperature: "Temperature",
    bloodPressure: "Blood Pressure",
    heartPulse: "Heart Pulse",
    respiratory: "Respiratory",
    VitalNurseEmployeeId: "Assigned Nurse",
    appointmentId: "Appointment",
    notes: "Notes",
  };

  const getVitalsDetails = async (currentPage) => {
    try {
      let res = await get(
        `/patients/vital-by-patientId?patientId=${patientId}&pageIndex=${currentPage}&pageSize=10`,
      );
      setVisits(res.data);
      setTotalPages(res.pageCount);
    } catch (error) {
      console.error("Error fetching visitation details:", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await get(
        `/appointment/get-appointment-bypatientId/${patientId}?pageIndex=${1}&pageSize=1000`,
      );

      let tempDoc = response?.data
        // ?.filter((item) => item?.tracking === "AwaitingVitals")
        ?.map((item, idx) => {
          // const appointTime =
          //   item?.appointTime === "00:00"
          //     ? "(Visit)"
          //     : `at ${item?.appointTime}`;
          // const doctorText = item?.doctorId ? `with ${item?.doctor}` : "";

          return {
            name: `${item?.appointDate} `,
            value: parseFloat(item?.id),
          };
        });

      tempDoc?.unshift({ name: "Select Appointment", value: "" });
      setAppointments(tempDoc);
      setPayload((prevPayload) => ({ ...prevPayload, appointmentId: "" }));
      setAppointmentPassed(false);
    } catch (e) {}
  };

  // const next = () => {
  //   setSelectedTab("treatment");
  // };

  useEffect(() => {
    // getCategoriesService();
    getCategories();
    // getNurses();
    // getDoctors();
    fetchData();
    getVitalsDetails(currentPage);
    // getVitalsByAppointmentId(appointmentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getVitalsDetails(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  // eslint-disable-next-line no-unused-vars
  // const _handleTranscript = (transcript) => {
  //   setPayload((prevPayload) => ({
  //     ...prevPayload,
  //     notes: prevPayload.notes
  //       ? prevPayload.notes + " " + transcript
  //       : transcript,
  //   }));
  // };

  const {
    // eslint-disable-next-line no-unused-vars
    setPatientId: _setPatientId,
    // eslint-disable-next-line no-unused-vars
    setPatientName: _setPatientName,
    // eslint-disable-next-line no-unused-vars
    setHmoId: _setHmoId,
    // eslint-disable-next-line no-unused-vars
    setPatientInfo: _setPatientInfo,
    patientName,
  } = usePatient();

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.3)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="modal-content"
        style={{
          background: "#fff",
          borderRadius: "8px",
          maxWidth: "900px",
          width: "90vw",
          maxHeight: "90vh",
          overflowY: "auto",
          position: "relative",
          padding: "32px 24px 24px 24px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
        }}
      >
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            background: "red",
            border: "none",
            fontSize: 28,
            cursor: "pointer",
            zIndex: 10,
          }}
          aria-label="Close"
        >
          <RiCloseFill />
        </button>
        <div className="w-100">
          <h2 className="p-20 w-100">Add services ({patientName})</h2>
          <div className="w-100 flex">
            <div className="col-8 m-l-20">
              <div>
                <div className="">
                  <div className="w-100">
                    <MemoizedTagInputs
                      label="Select Category"
                      name="category"
                      value={category}
                      onChange={(e) => handleSelectChange(e, "category")}
                      type="R-select"
                      options={categories}
                    />
                  </div>
                </div>
                {Array.isArray(services) && (
                  <div className="">
                    <div className="w-100">
                      <MemoizedTagInputs
                        label="Select Service"
                        name="serviceId"
                        value={service}
                        onChange={(e) => handleSelectChange(e, "serviceId")}
                        type="R-select"
                        options={services}
                      />
                    </div>
                  </div>
                )}
                {/* <TagInputs
                  onChange={handleChange}
                  value={payload?.appointmentId}
                  options={Appointments}
                  name="appointmentId"
                  label="Select Appointment/Visit"
                  type="select"
                /> */}
                <div className="w-100">
                  <TagInputs
                    onChange={(e) =>
                      setPayload({ ...payload, quantity: e.target.value })
                    }
                    value={payload?.quantity}
                    variation={true}
                    name="quantity"
                    label="Quantity"
                  />
                </div>
                <button
                  onClick={submitServicePayload}
                  className="submit-btn m-t-20 "
                >
                  Add Service
                </button>
              </div>
            </div>
            <div className="w-100 m-l-20">
              {/* <TagInputs
                onChange={handleChange}
                value={payload?.appointmentId}
                options={Appointments}
                name="appointmentId"
                label="Select Appointment/Visit"
                type="select"
              /> */}
              {/* <div className="w-100">
                <TagInputs
                  onChange={handleChange}
                  value={payload?.quantity}
                  variation={true}
                  name="quantity"
                  label="Quantity"
                />
              </div> */}
              <div className="w-100 m-t-20">
                <UnpaidServices
                  ref={unpaidRef}
                  payload={payload}
                  appointmentId={appointmentId}
                />
              </div>
              {/* onClick={onView} */}
              {/* {appointmentPassed && (
                        <div className="m-t-10">
                          <p style={{ color: 'red', marginBottom: '10px' }}>This appointment has passed. Please reschedule.</p>
                          <button className="col-6 submit-btn" onClick={() => handleEdit(payload?.appointmentId)}>
                            Reschedule Appointment
                          </button>
                        </div>
                      )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddExtraServices;
